
// export const myGetter = ( product ) => {
//  return product
// }

export const productsList = state => state.products
export const productsSelectable = state => state.productsSelectable
export const productListByTypeProductClientSelectable = state => state.productListByTypeProductClientSelectable
export const productsPaginatedData = state => state.productsPaginatedData
export const product = state => state.product
export const productSelect = state => state.productSelect
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData

export const productsByLoteData = state => state.productsByLoteData
export const isLoadingProductsByLote = state => state.isLoadingProductsByLote
export const productByNamePresentationClient = state => state.productByNamePresentationClient
export const productByNamePresentationClientIsCreating = state => state.productByNamePresentationClientIsCreating
export const productByNamePresentationClientTotalAmountUnitIsCreating = state => state.productByNamePresentationClientTotalAmountUnitIsCreating
export const productByNamePresentationClientTotalAmountUnit = state => state.productByNamePresentationClientTotalAmountUnit

export const productListByClientSelectable = state => state.productListByClientSelectable
export const isLoadingProductListByClient = state => state.isLoadingProductListByClient